import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-secondary flex items-center text-sm lg:text-base font-basier font-medium" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "24",
    height: "25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M4.25 6.37l5.75 7.4v6a1 1 0 001 1h2a1 1 0 001-1v-6l5.74-7.4a1 1 0 00-.79-1.6H5.04a1 1 0 00-.79 1.6z",
      fill: "#51747D"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-2 mr-2 whitespace-nowrap" }, " Pokaż wszystkie "),
  /*#__PURE__*/_createElementVNode("svg", {
    width: "9",
    height: "6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M4.5 5.26l4.5-5H0l4.5 5z",
      fill: "#51747D"
    })
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"container px-4 mx-auto text-left pt-10 lg:pb-10 flex justify-between items-center\"><div class=\"lg:flex\"><div class=\"border border-gray flex items-center p-4 rounded-lg hover:bg-gray cursor-pointer mb-2 lg:mb-0 lg:mx-3 first:lg:ml-0 transition\"><p> Łączny tonaż wyładunkowy </p><span class=\"text-black font-bold ml-10 whitespace-nowrap font-basier\">999 t</span></div><div class=\"border border-gray flex items-center p-4 rounded-lg hover:bg-gray cursor-pointer mb-2 lg:mb-0 lg:mx-3 first:lg:ml-0 transition\"><p> Łączny koszt przewoźnika </p><span class=\"text-black font-bold ml-10 whitespace-nowrap font-basier\"> 10123 zł </span></div></div></div>", 1)
const _hoisted_3 = { class: "container px-4 mx-auto text-left pt-10 pb-10 flex justify-between items-center" }
const _hoisted_4 = { class: "lg:grid lg:grid-cols-2 gap-4 w-full" }

import { UiHeading } from '@/components/common/ui'
import TheCard from '@/components/card/TheCard.vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(UiHeading), { title: "Dodaj dokumenty" }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (card) => {
          return _createVNode(TheCard, { key: card })
        }), 64))
      ])
    ])
  ], 64))
}
}

})